import { call, put, takeLatest } from "redux-saga/effects";
import {
  getSubjectBasedTeachersRequest,
  getSubjectBasedTeachersSuccess,
} from "./subjectBasedTeachersSlice"; 
import { getAllSubjectBasedTeachers } from "../../api/SubjectBasedTeachers/SubjectBasedTeachersService";

function* fetchSubjectBasedTeachersSaga(action) {
  try {
    const { formData } =  action.payload
    const response = yield call(getAllSubjectBasedTeachers, formData);
    yield put(getSubjectBasedTeachersSuccess(response?.data)); 
  } catch (error) {
    yield put(getSubjectBasedTeachersSuccess([])); 
  }
}

export default function* watchSubjectBasedTeachers() {
  yield takeLatest(getSubjectBasedTeachersRequest.type, fetchSubjectBasedTeachersSaga);
}

